import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ResetPasswordRequest,
  login,
  LoginRequest,
  signUp,
  SignUpRequest,
  resetPassword,
  verifySecurityCode,
  SecurityCodePayload,
  NewPasswordData,
  setNewPassword,
  refreshToken,
  SwipeRequest,
  swipeLogin,
  logout,
} from '@app/api/auth.api';
import { setUser } from '@app/store/slices/userSlice';
import { deleteExpiryDate, deletePermission, deleteReportMenus, deleteToken, deleteUser, persistToken, readToken } from '@app/services/localStorage.service';
import { setPermission } from './permissionSlice';
import { setExpiryDate } from './expiryDateSlice';
import { getExpiryDateFromToken } from '@app/utils/utils';
import { setReportMenu } from './reportSlice';

export interface AuthSlice {
  token: string | null;
}

const initialState: AuthSlice = {
  token: readToken(),
};

export const doLogin = createAsyncThunk('auth/login', async (loginPayload: LoginRequest, { dispatch }) =>
  login(loginPayload).then((res: any) => {
    if (res) {

      // const { userRole, createdOnUtc, updatedOnUtc, deletedOnUtc, ...user} = res.data.user;

      const { createdOnUtc, updatedOnUtc, deletedOnUtc, ...user } = res.data.user;
      const { reportMenus } = res.data;
      // const { rolePermissions } = userRole;
      // const { createdOnUtc, updatedOnUtc, deletedOnUtc, ...userRole} = userRole;
      dispatch(setUser(user));
      dispatch(setPermission(res.data.permissions));
      dispatch(setReportMenu(reportMenus));
      dispatch(setExpiryDate(getExpiryDateFromToken(res.data.access_token) ?? 0));
      persistToken(res.data.access_token);
     
      return res.data.access_token;
    } else {
      return undefined;
    }
  }),
);

export const doSwipe = createAsyncThunk('auth/SwipeLogin', async (loginPayload: SwipeRequest, { dispatch }) =>
  swipeLogin(loginPayload).then((res: any) => {
    if (res) {

      const { userRole, createdOnUtc, updatedOnUtc, deletedOnUtc, ...user } = res.data.user;
      const { reportMenus } = res.data;
      const { rolePermissions } = userRole;
      // const { createdOnUtc, updatedOnUtc, deletedOnUtc, ...userRole} = userRole;
      dispatch(setUser(user));
      dispatch(setPermission(rolePermissions));
      dispatch(setReportMenu(reportMenus));
      dispatch(setExpiryDate(getExpiryDateFromToken(res.data.access_token) ?? 0));
      persistToken(res.data.access_token);

      return res.data.access_token;
    } else {
      return undefined;
    }
  }),
);

export const doRefreshToken = createAsyncThunk('auth/refreshToken', async (payload, { dispatch }) =>
  refreshToken().then((res: any) => {

    if (res) {
      const { userRole, createdOnUtc, updatedOnUtc, deletedOnUtc, ...user } = res.data.user;
      const { rolePermissions } = userRole;
      const { reportMenus } = res.data;
      // const { createdOnUtc, updatedOnUtc, deletedOnUtc, ...userRole} = userRole;
      dispatch(setUser(user));
      dispatch(setPermission(rolePermissions));
      dispatch(setReportMenu(reportMenus));
      dispatch(setExpiryDate(getExpiryDateFromToken(res.data.access_token) ?? 0));
      persistToken(res.data.access_token);

      return res.data.access_token;
    } else {
      return undefined;
    }
  }),
);

export const doSignUp = createAsyncThunk('auth/doSignUp', async (signUpPayload: SignUpRequest) =>
  signUp(signUpPayload),
);

export const doResetPassword = createAsyncThunk(
  'auth/doResetPassword',
  async (resetPassPayload: ResetPasswordRequest) => resetPassword(resetPassPayload),
);

export const doVerifySecurityCode = createAsyncThunk(
  'auth/doVerifySecurityCode',
  async (securityCodePayload: SecurityCodePayload) => verifySecurityCode(securityCodePayload),
);

export const doSetNewPassword = createAsyncThunk('auth/doSetNewPassword', async (newPasswordData: NewPasswordData) =>
  setNewPassword(newPasswordData),
);

export const doLogout = createAsyncThunk('auth/doLogout', async (autoLogout: boolean = true, { dispatch }) => {

  logout(autoLogout).then(() => {
    deleteToken();
    deleteUser();
    deletePermission();
    deleteReportMenus();
    deleteExpiryDate();
    dispatch(setUser(null));
  });
});


const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doLogin.fulfilled, (state, action) => {
      state.token = action.payload;
    });
    builder.addCase(doSwipe.fulfilled, (state, action) => {
      state.token = action.payload;
    });
    builder.addCase(doLogout.fulfilled, (state) => {
      state.token = '';
    });
  },
});

export default authSlice.reducer;
